if ($("footer#footer").length) {
  $("#signature").css("display", "flex");
  $("#signature a.title").text("Běžíme na Shoptet");
  $("#signature").prepend('<span class="shopcode"><a href="https://www.shopcode.cz/?utm_source=kodovani&utm_medium=signature&utm_campaign=bes-petrovice" target="_blank" >Shopcode</a></span>');

  $(document).on("click", ".custom-footer > div .tls", function () {
    const parent = $(this).closest(".custom-footer > div");
    $(".custom-footer > div").not(parent).removeClass("open");
    parent.toggleClass("open");
  });

  $("footer#footer").before($(".instagramFeed"));

  $(".igPost.special .socials").append($("footer#footer .contact-box li span.facebook").closest("li").clone());
  $(".igPost.special .socials").append($("footer#footer .contact-box li span.instagram").closest("li").clone());
  $(".instagram-widget>a").each(function () {
    $(".instagramFeed .igFeed").append('<div class="igPost"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>');
  });

  $("footer#footer .needHelp").after($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));
  $("footer#footer .needHelp").after($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));

  $("footer#footer  li.mail").append(`<span class="info">${mailInfo}</span>`);
  $("footer#footer  li.tel").append(`<span class="info">${telefonInfo}</span>`);

  $("footer#footer .socials").append($("footer#footer .contact-box li span.facebook").closest("li").clone());
  $("footer#footer .socials").append($("footer#footer .contact-box li span.instagram").closest("li").clone());
}
